import { getField, updateField } from 'vuex-map-fields'
import moment from 'moment'

export const state = () => ({
  dateInterval: {
    timestamp1: moment().subtract(1, 'week').startOf('day').format('YYYY-MM-DD[T]HH:mm:ss'),
    timestamp2: moment().endOf('day').format('YYYY-MM-DD[T]HH:mm:ss'),
    select: { key: 'Geral', value: 'all' },
    menu: { key: 'Todos', value: 'all' },
    submenu: { name: 'todos', value: 'all' }
  }
})

export const getters = {
  getField
}

export const mutations = {
  updateField,
  setDateInterval (state, payload) {
    state.dateInterval = {
      ...state.dateInterval,
      ...payload
    }
  }
}

export const actions = {
  updateDateInterval ({ commit }, payload) {
    commit('setDateInterval', payload)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
